import { addDays, parseISO, startOfDay } from 'date-fns';
import { evaluateTripJoinability } from '../config/sharedTransferRules';
import { getTripCapacity } from './tripSchedule';

export function filterUpcomingTrips(trips) {
  return trips.filter((trip) => {
    const departureIso = `${trip.travel_date}T${trip.time_window_start || '00:00:00'}`;
    const departureTime = new Date(departureIso);
    if (isFinite(departureTime) && departureTime < new Date()) return false;
    if (!['open', 'confirmed'].includes(trip.status)) return false;

    const joinable = evaluateTripJoinability(trip);
    if (!joinable.ok) {
      if (
        joinable.reason === 'join_cutoff_open'
        || joinable.reason === 'join_cutoff_confirmed'
        || joinable.reason === 'trip_closed'
      ) {
        return false;
      }
      // too_far_ahead trips remain visible in browse until inside the join window.
    }

    if (trip.status === 'confirmed') {
      const capacity = getTripCapacity(trip);
      if ((trip.seats_filled ?? 0) >= capacity) return false;
    }

    return true;
  });
}

export function filterTripsInDayRange(trips, dayCount, fromDate = new Date()) {
  const rangeEnd = addDays(startOfDay(fromDate), dayCount);
  return trips.filter((trip) => {
    try {
      const travelDay = startOfDay(parseISO(trip.travel_date));
      if (travelDay < startOfDay(fromDate) || travelDay >= rangeEnd) return false;
    } catch {
      return false;
    }
    return true;
  });
}

export function getQuickDateFilter(filterType) {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const thisWeekend = new Date(today);
  const dayOfWeek = today.getDay();
  const daysUntilWeekend = dayOfWeek === 0 ? 0 : 6 - dayOfWeek;
  thisWeekend.setDate(thisWeekend.getDate() + daysUntilWeekend);
  switch (filterType) {
    case 'today':
      return today.toISOString().split('T')[0];
    case 'tomorrow':
      return tomorrow.toISOString().split('T')[0];
    case 'thisWeekend':
      return thisWeekend.toISOString().split('T')[0];
    default:
      return '';
  }
}